export default __webpack_public_path__ + "static/media/151-chairs.9ff26e89.png";